<template>
    <li class="card card--course card--accommodation card--backed card--colour-white card--standard card--fixed">    
        <a :href="url" class="card__inner" :class="{ 'text--center': center_content }" >
            <div class="card__body">
                <div class="card__image">
                    <img :src="image_url" :alt="title">
                </div>
                <div class="card__text">
                    <h3 v-html="title" class="card__title" :class="{ 'u-chevron u-chevron--inline': !hide_card_arrows }">
                        {{ title }}
                    </h3>
                    <div class="card__description" v-if="content !== null && card_text.length > 0">{{ card_text }}</div>
                </div>
            </div>
            <div class="card__footer card__tags" v-if="show_labels.categories || show_labels.tags">
                <span v-if="show_labels.categories" class="card__tag categories u-accent" style="white-space: normal; display: block;">{{ categories_to_string }}</span>
                <span v-if="show_labels.tags" class="card__tag tags u-accent" style="white-space: normal; display: block;">{{ tags_to_string }}</span>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        image_url: String,
        title: String,
        short_title: String,
        url: String,
        text: String,
        center_content: Boolean,
        hide_card_arrows: Boolean,
        categories: Array,
        tags: Array,
        show_labels: Array
    },
    data() {
        return {
            card_text: ''
        }
    },
    watch: {        
        text() {      
            // Moved this call into a watch. Was not updating when content being filtered and using old text value
            this.card_text = this.trim_and_elipsis(this.text);
        }
    },
    computed: {
        card_title() {
            if(this.short_title !== null && this.short_title.length > 0) {
                return this.short_title;
            } else {
                return this.title;
            }
        },
        categories_to_string() {
            let categories_string = "";
            for(let i = 0; i < this.categories.length; i++) {
                categories_string += i < this.categories.length - 1 ? this.categories[i] + ", " : this.categories[i];
            }
            return categories_string;
        },
        tags_to_string() {
            let tags_string = "";
            for(let i = 0; i < this.tags.length; i++) {
                tags_string += i < this.tags.length - 1 ? this.tags[i] + ", " : this.tags[i];
            }
            return tags_string;
        }
    },
    methods: {
        trim_and_elipsis(string) {
            if(string.length >= 165) {
                return string.substring(0,165) + '...';
            } else {
                return string;
            }
        }
    },
    created() {
        this.card_text = this.trim_and_elipsis(this.text);
    }
}
</script>
